module.exports = __webpack_public_path__ + "img/pr-2.2eb1d46c.png";